<template>
  <div id="signature" :class="isSigned ? type + '_area off' : type + '_area'">
    <!-- 서명 후 : off 클래스 적용 -->
    <VueSignaturePad
      width="100%"
      height="100%"
      ref="signaturePad"
      :options="{ ...options }"
    />
    <span class="signatureTxt" v-show="!isSigned">{{
      type == 'name' ? `(${text}/NAME)` : `(서명/SIGN)`
    }}</span>
    <button
      type="button"
      class="btn_clear"
      :class="isSigned ? 'active' : ''"
      @click="undo"
    >
      <!-- 활성화 클래스 : active -->
      <span class="blind">초기화</span>
    </button>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'MblElcSignaturePad',
  props: {
    type: String,
    text: String,
  },
  setup(props) {
    const signaturePad = ref(null)
    const isSigned = ref(false)

    const options = {
      penColor: '#333',
      dotSize: (1.5 + 3.5) / 2,
      minWidth: 1.5,
      maxWidth: 3.5,
      onBegin: function() {
        isSigned.value = true
      },
      onEnd: function() {},
    }

    const undo = () => {
      isSigned.value = false
      signaturePad.value.clearSignature()
    }

    // const onBegin = (r) => {
    //     isSigned.value = true
    // }

    return {
      signaturePad,
      isSigned,
      options,
      undo,
    }
  },
}
</script>

<style scoped>
.signatureTxt {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #8d7cd3;
  font-weight: bold;
  font-size: 22px;
  font-family: 나눔고딕;
}
</style>
